import React, { useState, useEffect } from 'react';
import { Input, Button, Badge, Table, notification } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import labels from '../../util/labels.json';
import '../../index.css';
import 'tailwindcss/tailwind.css';
import onboardingUsers from '../../data/onboardingusers.json';
import { searchPageColumns, getRowClassName, pageSize } from '../../util/columnsConfig.js';
import '../Admin/SearchPage.css';
import axios from 'axios';
import { useSelector } from "react-redux";
import { getOnboardingUser } from '../../services/Service';
import { showErrorNotification,showNotification, showWarningNotification } from '../../util/documentConfig';

const SearchPage = () => {
  // State variables
  const [searchInput, setSearchInput] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [gridData, setGridData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [activePage, setActivePage] = useState("");
  
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = sessionStorage.getItem('APP_BASE_PATH')
  // Retrieve authentication token from Redux store
  const token = useSelector((state) => state.auth.token);

  // Effect to disable scrolling on mount and enable on unmount
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // Effect to load data from location state
  useEffect(() => {
    if (location.state) {
      setGridData(location.state.gridData || []);
      setSelectedUsers(location.state.selectedUsers || []);
      setSelectedRowKeys(location.state.selectedRowKeys || []);
    } else {
      setGridData([]);
      setSelectedUsers([]);
      setSelectedRowKeys([]);
    }
  }, [location.state]);

  // Function to handle user search
  const handleSearch = async () => {
    const trimmedInput = searchInput.trim();
 
    if (!trimmedInput) {
      showErrorNotification(labels.invalidUID);
      return;
    }
 
    try {
      // API call to fetch onboarding user data
      const response = await getOnboardingUser(trimmedInput);
      const newUser = response;
 
      const alreadyAdded = gridData.some(
        user => user.uid.toLowerCase() === trimmedInput.toLowerCase()
      );
 
      if (alreadyAdded) {
        showWarningNotification(labels.userAlreadyExists);
      } else {
        setGridData([...gridData, newUser]);
        console.log('Updated Grid Data:', [...gridData, newUser]);
        showNotification(labels.userAdded );
      }
    } catch (error) {
      showErrorNotification(labels.userNotFound);
    }
 
    setSearchInput("");
  };

  // Table row selection configuration
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedUsers(selectedRows);
    },
    getCheckboxProps: record => ({
      name: record.uid,
    }),
  };

  // Function to navigate to the cart page
  const handleCartClick = () => {
    if (selectedUsers.length > 0) {
      navigate(`${basePath}/cart`, { state: { selectedUsers, gridData, selectedRowKeys } });
    }
  };

  // Sidebar state and toggle function
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
       <div className="max-w-7xl mx-auto p-3 bg-white space-y-8 mt-8 overflow-hidden"  style={{ height: '580px'}}>
       <h2 className="header">{labels.onboardingHeader}</h2>

       <div className="flex justify-between items-center p-1 flex-none">
      <div className="flex items-center space-x-4">
        <Input
          placeholder="Enter Employee ID (e.g., U300001)"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="search-input border border-gray-300 p-2"
        />
        <Button
          type="primary"
          className="bg-[#183D5D] text-white rounded-full px-5 py-5 text-m flex items-center gap-4 shadow-xl"
          onClick={handleSearch}
        >
          {labels.searchButton}
        </Button>
        </div>
          <Badge count={selectedUsers.length}>
            <ShoppingCartOutlined
              className={`text-4xl ${selectedUsers.length === 0 ? 'text-gray-400' : 'text-blue-800'}`}
              onClick={handleCartClick}
              disabled={selectedUsers.length === 0}
            />
          </Badge>
          </div>

        <div className="bg-white border border-gray-200 rounded-lg shadow-lg">
          <Table
            dataSource={gridData}
            rowKey="uid"
            rowClassName={getRowClassName}
            rowSelection={{
              type: "checkbox",
              ...rowSelection,
            }}
            pagination={{
              pageSize,
              showSizeChanger: false,
              position: ['bottomCenter'],
            }}
            bordered
            style={{ width: '100%' }}
            scroll={{ y: 250 }}
            columns={searchPageColumns(gridData).map(col => ({
              ...col,
              onHeaderCell: () => ({
                style: {
                  backgroundColor: 'var(--color-primary)',
                  color: 'white',
                  fontWeight: 'bold',
                  position: 'sticky',
                  top: 0,
                  zIndex: 100,
                },
              }),
            }))}
          />
        </div>
      </div>
  );
};

export default SearchPage;
